import { useMemo } from 'react';
import {
  Entity,
  RELATION_OWNED_BY,
  RELATION_PART_OF,
} from '@backstage/catalog-model';
import { EntityErrorResult } from '@agilelab/plugin-wb-catalog-extension-common';
import { GetEntitiesResponse } from '@backstage/catalog-client';
import { buildReservedFieldError } from '../../ReservedFieldsError/ReservedFieldsError';
import {
  getEntityRelations,
  humanizeEntityRef,
} from '@backstage/plugin-catalog-react';
import { WitboostSystem } from '@agilelab/plugin-wb-builder-common';

interface Props {
  entities: Entity[];
  errors: EntityErrorResult[] | undefined;
  dpResponse: GetEntitiesResponse | undefined;
}

export function useRows({ entities, errors, dpResponse }: Props) {
  const rows = useMemo(
    () =>
      entities.map(entity => {
        const entityError: string | undefined = (errors ?? []).find(
          e => e.entity_id === entity.metadata.uid,
        )?.errorMessage;

        const reservedFieldError = buildReservedFieldError(entity);

        const partOfSystemRelations = getEntityRelations(
          entity,
          RELATION_PART_OF,
          {
            kind: 'system',
          },
        );
        const ownedByRelations = getEntityRelations(entity, RELATION_OWNED_BY);

        return {
          entity,
          error: entityError || reservedFieldError,
          resolved: {
            name: humanizeEntityRef(entity, {
              defaultKind: 'Component',
            }),
            ownedByRelationsTitle: ownedByRelations
              .map(r => humanizeEntityRef(r, { defaultKind: 'group' }))
              .join(', '),
            ownedByRelations,
            partOfSystemRelationTitle: partOfSystemRelations
              .map(
                r =>
                  (
                    dpResponse?.items.find(
                      e =>
                        e.metadata.name.toLowerCase() === r.name.toLowerCase(),
                    ) as WitboostSystem
                  )?.spec.mesh.name || r.name,
              )
              .join(', '),
            partOfSystemRelations,
          },
        };
      }),
    [entities, errors, dpResponse],
  );

  return rows;
}
